/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_SavingInputs */



/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Spaces_Codeeditor_SavingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_saving = /** @type {((inputs?: Spaces_Codeeditor_SavingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_SavingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichere...")
	return /** @type {LocalizedString} */ ("Saving...")
});